import { SceneTimeRangeTransformerBase } from './SceneTimeRangeTransformerBase.js';
import { getDefaultTimeRange } from '@grafana/data';
import { evaluateTimeRange } from '../utils/evaluateTimeRange.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
class SceneTimeZoneOverride extends SceneTimeRangeTransformerBase {
  constructor(state) {
    super(__spreadProps(__spreadValues({}, state), {
      timeZone: state.timeZone,
      from: "now-6h",
      to: "now",
      value: getDefaultTimeRange()
    }));
  }
  ancestorTimeRangeChanged(timeRange) {
    this.setState(__spreadProps(__spreadValues({}, timeRange), {
      timeZone: this.state.timeZone,
      value: evaluateTimeRange(
        timeRange.from,
        timeRange.to,
        this.state.timeZone,
        timeRange.fiscalYearStartMonth,
        timeRange.UNSAFE_nowDelay
      )
    }));
  }
  getTimeZone() {
    return this.state.timeZone;
  }
  onTimeZoneChange(timeZone) {
    this.setState({
      timeZone,
      value: evaluateTimeRange(
        this.state.from,
        this.state.to,
        this.state.timeZone,
        this.getAncestorTimeRange().state.fiscalYearStartMonth,
        this.state.UNSAFE_nowDelay
      )
    });
  }
}

export { SceneTimeZoneOverride };
//# sourceMappingURL=SceneTimeZoneOverride.js.map
